import { render, staticRenderFns } from "./EditService.vue?vue&type=template&id=506f98a3&scoped=true&"
import script from "./EditService.vue?vue&type=script&lang=js&"
export * from "./EditService.vue?vue&type=script&lang=js&"
import style0 from "./EditService.vue?vue&type=style&index=0&id=506f98a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f98a3",
  null
  
)

export default component.exports